import Table from "react-bootstrap/Table";
import { stateIndices } from "../ReactionPaths.js";
import { MathJax, MathJaxContext } from "better-react-mathjax";
import Container from "react-bootstrap/Container";

const RelatedReactionTable = ({ relatedReactionData }) => {
  if (relatedReactionData?.length > 0) {
    function onlyUnique(value, index, array) {
      return array.indexOf(value) === index;
    }
    let potentials = relatedReactionData
      .map((reaction) => {
        return reaction.reaction.potential;
      })
      .filter(onlyUnique)
      .sort((a, b) => a - b);

    let reactions = relatedReactionData
      .map((reaction) => {
        return reaction.reaction.reaction_type;
      })
      .filter(onlyUnique);

    let reactionsOrganized = {};
    relatedReactionData.forEach((reaction, reaction_i) => {
      let reactionType = reaction.reaction.reaction_type;
      if (!(reactionType in reactionsOrganized)) {
        reactionsOrganized[reactionType] = {};
      }
      reactionsOrganized[reactionType][reaction.reaction.potential] = reaction;
    });

    let borderStyle = { borderLeft: "2px solid #CCC" };
    let tableHead = [
      <th>Descriptor/Reaction</th>,
      ...potentials.map((potential) => {
        return <th style={borderStyle}>{potential.toPrecision(3)} V</th>;
      }),
    ];

    let ulRows = reactions.map((reaction, reaction_i) => {
      let rowData = [
        <td>
          <MathJax inline={true}>{"\\(U_L\\)"}</MathJax> ({reaction})
        </td>,
        ...potentials.map((potential, potential_i) => {
          let relatedReaction = reactionsOrganized[reaction][potential];
          let onclick = () => {};
          if (relatedReaction !== undefined) {
            onclick = () => {
              window.open(
                "/catalyst_path/" +
                  reactionsOrganized[reaction][potential].unique_id,
              );
            };
          }
          let ul = "N/A";
          if (relatedReaction !== undefined) {
            ul =
              reactionsOrganized[reaction][
                potential
              ].reaction.limiting_potential.toFixed(3);
          }
          return (
            <td
              onClick={onclick}
              className="reaction-table-cell"
              style={borderStyle}
            >
              <div className="px-3 py-0"> {ul}</div>
            </td>
          );
        }),
      ];
      return <tr>{rowData}</tr>;
    });

    let pmRows = reactions.map((reaction, reaction_i) => {
      let rowData = [
        <td>
          <MathJax inline={true}>{"\\(\\Phi_{\\mathrm{max}}\\)"}</MathJax> (
          {reaction})
        </td>,
        ...potentials.map((potential, potential_i) => {
          let relatedReaction = reactionsOrganized[reaction][potential];
          let onclick = () => {};
          if (relatedReaction !== undefined) {
            onclick = () => {
              window.open(
                "/catalyst_path/" +
                  reactionsOrganized[reaction][potential].unique_id,
              );
            };
          }
          let pm = "N/A";
          if (relatedReaction !== undefined) {
            pm =
              reactionsOrganized[reaction][
                potential
              ].reaction.energetic_span.toFixed(3);
          }
          return (
            <td
              onClick={onclick}
              className="reaction-table-cell"
              style={borderStyle}
            >
              <div className="px-3 py-0"> {pm}</div>
            </td>
          );
        }),
      ];
      return <tr>{rowData}</tr>;
    });

    return (
      <MathJaxContext>
        <Container>
          <Table hover>
            <tbody>
              <tr>{tableHead}</tr>
              {ulRows}
              {pmRows}
            </tbody>
          </Table>
        </Container>
      </MathJaxContext>
    );
  }
};

export { RelatedReactionTable };
